import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import { ToastMessages } from "../../../../components/toasts/toastMessages";
import { CopyIcon } from "../../../../svg/copy-icon";

interface MultilineCellProps {
  value: { mainText: any; secondaryText: any };
  [key: string]: any;
  shouldShowLeftBorder?: boolean;
  leftBorderColor?: string;
}

export const MultilineCell: React.FC<MultilineCellProps> = ({
  value,
  shouldShowLeftBorder,
  leftBorderColor,
}) => {
  const isMRN = value.secondaryText && value.secondaryText.includes("MRN :");
  let copyValue = "";

  if (isMRN) {
    copyValue = value.secondaryText.split("MRN :")[1]?.trim() || "";
  }

  return (
    <>
      <div
        className={`table-cell-multiline-text w-full ${shouldShowLeftBorder ? "h-[100%] border-l-4 p-3" : ""}`}
        style={
          shouldShowLeftBorder
            ? { borderLeftColor: leftBorderColor }
            : { borderLeftColor: "transparent" }
        }
      >
        <div className="table-cell-multiline-text__main" title={value.mainText}>
          {value.mainText}
        </div>
        <div className="flex items-center gap-2">
          <div className="table-cell-multiline-text__secondary">
            {value.secondaryText}
          </div>
          {
            <div
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(
                  isMRN ? copyValue : value.secondaryText,
                );
                toast.success(ToastMessages.KEY_COPY_SUCCESS);
              }}
              className="cursor-pointer"
            >
              <CopyIcon />
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default MultilineCell;
